import { render, staticRenderFns } from "./GoodsReturnNote.vue?vue&type=template&id=89222686"
import script from "./GoodsReturnNote.vue?vue&type=script&lang=js"
export * from "./GoodsReturnNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports